import React, { useEffect } from 'react'
import Layout from '../Layout'
import Sectionone from './Sectionone'
import Intro from './Intro'
import AllModules from './AllModules'
import BroucherSection from './BroucherSection'
import MakeMMB from './Make_MMB'
import GrowthPlanSection from './GrowthPlanSection'
import HeadwayITGrowthPlan from '../HeadwayIT/HeadwayITGrowthPlan'
import ResBrochureSection from './ResBrochureSection'
import MMBGallery from './MMBGallery'
import AllSectionone from '../ReusableComp/Sectionone';
import * as Images from '../../assets';
import MMBGallerySlider from './MMBGallerySlider'
import { fetchWithFormData } from '../../apiGeneralFunction'
import { trackCustomEvent } from '../../event_firebase';

const staticModules = [
  {
    id: 1,
    title: ' Business Reality',
    imgUrl: `${Images.mmb_icon_one}`,
    features: [
      {
        id: 1,
        feature: 'What is Business?',
      },
      {
        id: 2,
        feature: 'Why Do Business Only?',
      },
      {
        id: 3,
        feature: 'Features of Business',
      },
      {
        id: 4,
        feature: 'Business Psychology',
      },
      {
        id: 5,
        feature: 'Power of Thoughts',
      },
      {
        id: 6,
        feature: 'Effective Sensory Business',
      },
      {
        id: 7,
        feature: `Work &amp; Time Management`,
      },
      {
        id: 8,
        feature: `Steps to Start a Business`,
      },
      {
        id: 9,
        feature: `Growth Model of Business`,
      },
      {
        id: 10,
        feature: 'Product Mastery: Getting It Right',
      },
      {
        id: 11,
        feature: 'Review &amp; Audit System',
      },
      {
        id: 12,
        feature: 'Vision, Mission, &amp; Values',
      },
      {
        id: 13,
        feature: 'Ownerless Business Management',
      },
      {
        id: 14,
        feature: 'Daily Follow-ups &amp; Pressure Points',
      },
      {
        id: 15,
        feature: 'Revenue Generation',
      },

    ]

  },
  {
    id: 2,
    title: ' Business &amp; People Management',
    imgUrl: `${Images.mmb_icon_two}`,
    features: [
      {
        id: 1,
        feature: 'Why Do You Require Workforce Management?',
      },
      {
        id: 2,
        feature: 'What is Human Resource Management?',
      },
      {
        id: 3,
        feature: 'Interview, Introduction, and Induction',
      },
      {
        id: 4,
        feature: 'Recruitment Process and Policy',
      },
      {
        id: 5,
        feature: 'Setting up for Success',
      },
      {
        id: 6,
        feature: 'Crafting Responsibility &amp; Building Professional Profile',
      },
      {
        id: 7,
        feature: 'Review and Reporting System',
      },
      {
        id: 8,
        feature: 'KRA-KPI Performance Metrics',
      },
      {
        id: 9,
        feature: 'Incentive, Appraisal, Motivation and Promotion',
      },
      {
        id: 10,
        feature: 'Training &amp; Development',
      },
      {
        id: 11,
        feature: 'Work Culture Transformation',
      },
      {
        id: 12,
        feature: 'Evaluation of Employees',
      },

    ]
  },
  {
    id: 3,
    title: ' Business Strategic Planning',
    imgUrl: `${Images.mmb_icon_three}`,
    features: [
      {
        id: 1,
        feature: 'What is Strategy?',
      },
      {
        id: 2,
        feature: 'Why Strategic Planning is Required?',
      },
      {
        id: 3,
        feature: 'How to Create a GOAL',
      },
      {
        id: 4,
        feature: 'Strategy v/s Plan',
      },
      {
        id: 5,
        feature: 'Proportion in Strategy',
      },
      {
        id: 6,
        feature: 'Characteristics of Strategy',
      },
      {
        id: 7,
        feature: 'Power of Projection',
      },
      {
        id: 8,
        feature: 'Subjective Strategy',
      },
      {
        id: 9,
        feature: 'MBSS - My Business Strategy Sheet',
      },
      {
        id: 10,
        feature: 'Statistical Fundamentals',
      },
      {
        id: 11,
        feature: 'SWOT Analysis',
      },
      {
        id: 12,
        feature: 'Data Analysis',
      },
      {
        id: 13,
        feature: 'Mystery Audit / Impromptu Audit',
      },
      {
        id: 14,
        feature: 'Feedback &amp; Review System',
      },

    ]
  },
  {
    id: 4,
    title: ' Business Finance Management',
    imgUrl: `${Images.mmb_icon_four}`,
    features: [
      {
        id: 1,
        feature: 'What is Business Finance?',
      },
      {
        id: 2,
        feature: 'Ways to Make Money',
      },
      {
        id: 3,
        feature: 'Budget Planning for Business',
      },
      {
        id: 4,
        feature: 'Invisible Cost &amp; Income',
      },
      {
        id: 5,
        feature: 'Cost &amp; Income Management',
      },
      {
        id: 6,
        feature: 'Alert &amp; Alarm of Finance',
      },
      {
        id: 7,
        feature: 'Power of AOP',
      },
      {
        id: 8,
        feature: 'Reviewing &amp; Feedback AOP',
      },
      {
        id: 9,
        feature: 'Creating Pre-Performing Balance Sheet',
      },
      {
        id: 10,
        feature: 'Forecasting P&amp;L / Cash Flow Data ',
      },
      {
        id: 11,
        feature: 'Different Ways of Arranging Finance',
      },
      {
        id: 12,
        feature: 'Communicating &amp; Implementing AOP',
      },
      {
        id: 13,
        feature: 'Finance Growth Model',
      },
      {
        id: 14,
        feature: 'Review &amp; Audit System',
      },

    ]
  },
  {
    id: 5,
    title: ' Business Team Building &amp; Management',
    imgUrl: `${Images.mmb_icon_five}`,
    features: [
      {
        id: 1,
        feature: 'Importance of a Team',
      },
      {
        id: 2,
        feature: 'Create a Leadership in a Team',
      },
      {
        id: 3,
        feature: 'Business SOPs',
      },
      {
        id: 4,
        feature: 'Implement &amp; Sustain SOPs',
      },
      {
        id: 5,
        feature: 'Create 4Ds in Development',
      },
      {
        id: 6,
        feature: 'Power of Effective 4Ds',
      },
      {
        id: 7,
        feature: '7 Effective Keys of Leadership',
      },
      {
        id: 8,
        feature: 'Transformative Leadership',
      },
      {
        id: 9,
        feature: 'Create a Work Culture',
      },
      {
        id: 10,
        feature: 'Build up a High-Value Team',
      },
      {
        id: 11,
        feature: 'Principles of Team Building',
      },
      {
        id: 12,
        feature: 'Skills &amp; Management Training',
      },
      {
        id: 13,
        feature: 'Responsibility &amp; Reporting System',
      },
      {
        id: 14,
        feature: 'Ownerless Process Management',
      },

    ]
  },
  {
    id: 6,
    title: ' Business Customer Relation Management (CRM)',
    imgUrl: `${Images.mmb_icon_six}`,
    features: [
      {
        id: 1,
        feature: 'What is Business CRM?',
      },
      {
        id: 2,
        feature: 'Business without CRM',
      },
      {
        id: 3,
        feature: 'Parameters of CRM',
      },
      {
        id: 4,
        feature: 'Benefits of CRM',
      },
      {
        id: 5,
        feature: 'Steps to Start CRM',
      },
      {
        id: 6,
        feature: 'Review &amp; Update Data System',
      },
      {
        id: 7,
        feature: 'Value of Feedback',
      },
      {
        id: 8,
        feature: 'Automation in CRM',
      },
      // {
      //     id: 9,
      //     feature: 'Benefits of CRM',
      // },
      {
        id: 9,
        feature: 'Power of Data',
      },
    ]
  },
  {
    id: 7,
    title: ' Business Customer Satisfaction',
    imgUrl: `${Images.mmb_icon_eight}`,
    features: [
      {
        id: 1,
        feature: 'What is Customer Satisfaction?',
      },
      {
        id: 2,
        feature: 'Why Must You Achieve Customer Delight?',
      },
      {
        id: 3,
        feature: 'How to Create Customer Satisfaction?',
      },
      {
        id: 4,
        feature: 'Customer Service &amp; Support',
      },
      {
        id: 5,
        feature: 'Customer Service Skill Training',
      },
      {
        id: 6,
        feature: 'Creating a Support System',
      },
      {
        id: 7,
        feature: 'Create a Brand Promotor',
      },
      {
        id: 8,
        feature: 'Steps to Start Customer Service',
      },
      {
        id: 9,
        feature: 'Growth Model of Customer Service',
      },
      {
        id: 10,
        feature: 'Review &amp; Feedback',
      },
      {
        id: 11,
        feature: 'Create Culture in Your Team',
      },
    ]
  },
  {
    id: 8,
    title: ' Business Product Management',
    imgUrl: `${Images.mmb_icon_ten}`,
    features: [
      {
        id: 1,
        feature: 'What is a Product?',
      },
      {
        id: 2,
        feature: 'Know Your Product',
      },
      {
        id: 3,
        feature: 'Quality &amp; Pricing',
      },
      {
        id: 4,
        feature: 'Types of a Product',
      },
      {
        id: 5,
        feature: 'Innovation in Product',
      },
      {
        id: 6,
        feature: 'Product Psychology',
      },
      {
        id: 7,
        feature: 'Power of Product',
      },
      {
        id: 8,
        feature: 'Product Strategy',
      },
      {
        id: 9,
        feature: 'Product Knowledge',
      },
      {
        id: 10,
        feature: 'Product Sales Skill Training',
      },
      {
        id: 11,
        feature: 'Product Presentation &amp; Display',
      },
      {
        id: 12,
        feature: 'Inventory Management',
      },
      {
        id: 13,
        feature: 'Promotion',
      },
      {
        id: 14,
        feature: 'Marketing &amp; Branding',
      },
      {
        id: 15,
        feature: 'Support &amp; Service',
      },

    ]
  },
  {
    id: 9,
    title: ' Business Branding &amp; Marketing',
    imgUrl: `${Images.mmb_icon_seven}`,
    features: [
      {
        id: 1,
        feature: 'Defining Brand Identity',
      },
      {
        id: 2,
        feature: 'Identifying Target Audience',
      },
      {
        id: 3,
        feature: 'Craft a Brand Message',
      },
      {
        id: 4,
        feature: 'Develop a Visual Identity',
      },
      {
        id: 5,
        feature: 'Optimize Online Presence',
      },
      {
        id: 6,
        feature: 'Utilize Marketing Techniques',
      },
      {
        id: 7,
        feature: 'Implement SEO Strategies',
      },
      {
        id: 8,
        feature: 'Leverage Social Media',
      },
      {
        id: 9,
        feature: 'Engage in Content Marketing',
      },
      {
        id: 10,
        feature: 'Measure and Analyze Performance',
      },


    ]
  },
  {
    id: 10,
    title: ' Business Skill Development',
    imgUrl: `${Images.mmb_icon_eleven}`,
    features: [
      {
        id: 1,
        feature: 'Identifying Key Skill Areas',
      },
      {
        id: 2,
        feature: 'Setting Learning Objectives',
      },
      {
        id: 3,
        feature: 'Accessing Training Resources',
      },
      {
        id: 4,
        feature: 'Hands-On Practical Exercises',
      },
      {
        id: 5,
        feature: 'Continuous Feedback and Evaluation',
      },
      {
        id: 6,
        feature: 'Adapting to Evolving Industry Trends',
      },
      {
        id: 7,
        feature: 'Mentorship and Coaching Programs',
      },
      {
        id: 8,
        feature: 'Networking Opportunities',
      },
      {
        id: 9,
        feature: 'Certification and Recognition',
      },
      {
        id: 10,
        feature: 'Creating a Personalized Learning Plan',
      },


    ]
  },
  {
    id: 11,
    title: ' Business Professional Meditation',
    imgUrl: `${Images.mmb_icon_twelve}`,
    features: [
      {
        id: 1,
        feature: 'Setting Intentional Goals',
      },
      {
        id: 2,
        feature: 'Mindful Awareness Practices',
      },
      {
        id: 3,
        feature: 'Stress Reduction Techniques',
      },
      {
        id: 4,
        feature: 'Focused Breathing Exercises',
      },
      {
        id: 5,
        feature: 'Time Management Techniques',
      },
      {
        id: 6,
        feature: 'Enhanced Concentration and Focus',
      },
      {
        id: 7,
        feature: 'Cultivating Emotional Resilience',
      },
      {
        id: 8,
        feature: 'Promoting Decision-Making Clarity',
      },
      {
        id: 9,
        feature: 'Building Effective Communication Skills',
      },
      {
        id: 10,
        feature: 'Fostering a Positive Work Environment',
      },


    ]
  },
  {
    id: 12,
    title: ' Business Evolution',
    imgUrl: `${Images.mmb_icon_nine}`,
    features: [
      {
        id: 1,
        feature: 'What is Business Evolution?',
      },
      {
        id: 2,
        feature: 'Total Business Evolution',
      },
      {
        id: 3,
        feature: 'Why Business Evolution only?',
      },
      {
        id: 4,
        feature: 'Review & audit system',
      },
      {
        id: 5,
        feature: 'Features of Business Evolution',
      },
      {
        id: 6,
        feature: 'FAQ',
      },
      {
        id: 7,
        feature: 'Business Psychology',
      },
      {
        id: 8,
        feature: `4Ps Evolution-People, Processes, Place & Profit`,
      },
      {
        id: 9,
        feature: `Power of Thought's`,
      },
      {
        id: 10,
        feature: 'Future Planning',
      },
      {
        id: 11,
        feature: 'Dream Decide, Declare your Path fornext 10 Years',
      },
      {
        id: 12,
        feature: 'Business Refreshment Meet',
      },


    ]
  },
]

const MakeMyBusiness = () => {
  const [data, setData] = React.useState({ brochure: '', galleries: [] });

  useEffect(() => {
    window.scrollTo(0, 0);

    const formData = new FormData();
    fetchWithFormData('mmb_gallaries', formData)
      .then(data => {
        if (data?.status === true) {
          setData(data?.data);
          trackCustomEvent('mmb_gallaries', { status: true });
        } else {
          setData([]);
          trackCustomEvent('mmb_gallaries', { status: false });
        }
      })
      .catch(() => { setData([]); trackCustomEvent('mmb_gallaries', { status: false }); });
  }, []);

  if (!data) return null; // or a loading spinner
  return (
    <>
      <Layout>
        {/* <Sectionone/> */}
        <AllSectionone
          src={Images.mmb_bg_new}
          // src={Images.make_my_business_bg}
          title={'Make My Business'}
          link_to2={'/our_services'}
          link_name2={'Our Services'}
          link_to3={'/make_my_business'}
          link_name3={'Make My Business'}
        />
        <Intro />
        {/* <MakeMMB/> */}
        <AllModules data={data?.mmb_services && data.mmb_services.length > 0 ? data.mmb_services : staticModules} />
        {/* <BroucherSection/> */}
        < ResBrochureSection data={data?.brochure} />
        {/* <MMBGallery/> */}
        <MMBGallerySlider data={data?.galleries} />
        <GrowthPlanSection />
        {/* <HeadwayITGrowthPlan/> */}
      </Layout>
    </>
  )
}

export default MakeMyBusiness